import { observable, action, flow, computed } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './ViewPackageServ';

class ViewPackageMod {
  @observable password = '';

  @observable applyType = '';

  @observable fromSource = '';
  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  /**
   * 根据id，获取商品列表
   * @param {string} id - 分类id
   * @param {string} keyword - 搜索关键词
   */
  getProductList = flow(function* ({ id: cardTypeId = '', keyword = '', shop }) {
    try {
      const thisValue = Util.getLocalCache(Config.localStorageKeys.member_cardSecret);
      console.log(thisValue, 'thisValuethisValuethisValuethisValue');
      let params = {
        cardTypeId
      };
      //腾晖云仓订单增加参数sourceChannel 0-其它、1-异业商城、2-权益仓库-入、3-权益仓库-出
      if (Util.getLocalCache(Config.localStorageKeys.th_cloud_warehouse)) {
        params.sourceChannel = 3;
      }
      const { data, resultCode, resultMsg } = shop
        ? yield Serv.getShopProductList(params)
        : yield Serv.getProductList(params);
      if (shop && resultCode !== '0' && resultCode !== '10004') {
        Toast.info(resultMsg);
        return null;
      }
      const list = data ? data.cardTypeItemList : [];
      return data;
    } catch (error) {}
  });
}
const viewPackageMod = new ViewPackageMod();
export default viewPackageMod;



// WEBPACK FOOTER //
// ./src/pages/Register/ViewPackage/ViewPackageMod.js